import { useState } from 'react';
import './App.css';

export default function App() {
  const [task, setTask] = useState('')
  const [tasks, setTasks] = useState([])
  const [filterCompleted, setFilterCompleted] = useState(false)

  function addTaskHandler() {
    let data = {
      title: task.trim(), 
      id: crypto.randomUUID(),
      isCompleted: false
    }

    if (data.title) { 
      setTasks([...tasks, data])
      setTask('')
    }
  }

  function replaceLastClass(element, newClass) {
    const classList = element.classList;
    const lastClass = classList.item(classList.length - 1)

    if (lastClass) {
      classList.remove(lastClass)
    }

    classList.add(newClass)
}

  function removeTaskHandler(e, id) {
   const taskElement = e.target.parentElement;
  
    replaceLastClass(taskElement, 'animate__fadeOutLeft');

    setTimeout(() => {
      const clearedTasks = tasks.filter((el) => el.id !== id);
      setTasks(clearedTasks);
    }, 400)
  }

  function setCompleted(id) {
    const completedTasks = tasks.map(el => {
      if (el.id === id) {
        return { ...el, isCompleted: !el.isCompleted }
      } else {
        return el
      }
    })
    setTasks(completedTasks)
  }

  function toggleCompletedFilter() {
    setFilterCompleted(!filterCompleted)
  }

  const displayedTasks = filterCompleted
    ? tasks.filter((el) => el.isCompleted)
    : tasks

  function sortTasks() {
    const sortedTasks = [...tasks].sort((a, b) => {
      if (a.title > b.title) {
        return 1
      }
      if (a.title < b.title) {
        return -1
      }
      return 0
    })
    setTasks(sortedTasks)
  }

  return (
    <div className="App">
      <h1>ToDo List</h1>
      <div className='container'>
        <div className='input-container'>
          <input type='text'
            className='add-task-input'
                  value={task}
                  onKeyDown={e => {if (e.keyCode === 13) addTaskHandler()}}
                  onChange={e => setTask(e.target.value.trimStart())} 
          >
          </input>
          <button onClick={addTaskHandler} 
          className='btn add-task-btn'>+</button>
        </div>
        
        <div>
          <button onClick={toggleCompletedFilter}
            className='btn'>Completed</button>
          <button onClick={() => setFilterCompleted(false)}
            className='btn'>Show All</button>
          <button onClick={() => sortTasks()}>Sort</button>
        </div>

      </div>

      <div className='tasks'>
        {displayedTasks.length ? displayedTasks.map(el => (
          <div className='task-wrapper container animate__animated animate__fadeInLeft' key={el.id}>
            <p onClick={() => setCompleted(el.id)}
              className={el.isCompleted ? 'completed' : 'incomplete'}
            >
              {el.title}
            </p>
            <button onClick={(e) => removeTaskHandler(e, el.id)}
              className='delete'>
              x
            </button>
          </div>
        )) : <p className='not-found-msg'>Tasks not found</p>}
      </div>
    </div>
  )
}